import { gql } from "@apollo/client";

const UPDATE_TOR_COMPONENT_TABLE_D = gql`
    mutation updateToRComponentTableD($componentID: String!, $laID: String!, $componentCode: String!, $componentTitle: String!, $gradeRegistered: String, $ects: String!, $semester: String){
      updateToRComponentTableD(componentID: $componentID, laID: $laID, componentCode: $componentCode, componentTitle: $componentTitle, gradeRegistered: $gradeRegistered, ects: $ects, semester: $semester)
  }
`;

export default UPDATE_TOR_COMPONENT_TABLE_D;
